import { Component, Inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { PageFilter } from '@core/model/pagination/filter';
import { States } from '@generated/queries';
import { UserService } from '@shared/services/user.service';
import { CreateLabor } from '../../models/ticket-labor';
import { AuthService } from '@core/services/auth.service';
import { noCommaValue } from '@core/mask/remove-comma';
import { TicketLabourService } from '../../services/ticket-labour.service';
import { NotifyService } from '@core/services/notify.service';
import { TicketsService } from '../../services/tickets.service';
import { Salary, SalarySetup } from '@core/model/employee/salary';
import { SalaryRateType } from '@core/enums/ticket-labor';

@Component({
  selector: 'app-add-team-member-and-hour',
  standalone: false,
  templateUrl: './add-team-member-and-hour.component.html',
  styleUrl: './add-team-member-and-hour.component.css'
})
export class AddTeamMemberAndHourComponent implements OnInit {
  ticketId: string;
  usersFilter: PageFilter = {
    pageIndex: 0,
    activeIndex: 0,
    take: 500,
    state : States.Active,
    search: '',
    };
  selectedUserId: string;
  workerId:string;
  loading = false;
  isEnableSaveButton= false;
  estimatedHoursOnly = false;
  laborHourRate: Salary[] = [];
  salaryType = SalaryRateType;

  constructor(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddTeamMemberAndHourComponent>,
    public userService: UserService,
    private authService: AuthService,
    private service: TicketLabourService,
    private notifyService: NotifyService,
    private ticketService: TicketsService
  ) {
    if(data?.estimatedHoursOnly){
      this.estimatedHoursOnly = data?.estimatedHoursOnly;
    }
    this.dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.stopPropagation();  // Prevent ESC from bubbling to parent dialog
        this.cancel();            // Only close this dialog
      }
    });
  }
  cancel() {
    this.dialogRef.close();
  }

assignees: { id: string | null; fullName: string | null; rHours: string | null; otHours: string | null ;emHours: string | null}[] =
  [{ id: null, fullName: null ,rHours: null, otHours: null, emHours: null}];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedUser: any = null;

  async ngOnInit(): Promise<void> {
    await this. userService.fetchUsers$(this.usersFilter,false);
    this.workerId = this.authService.id;
    this.ticketId = this.ticketService.selectedTicketId;
    this.laborHourRate = await this.service.getEmployeesSalaries();
  }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChangeUserSelection(event: any){
    this.selectedUserId = event;
    this.assignees[0].id = this.selectedUserId;
    this.isEnableSaveButton = true;
  }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChangeEstimatedHours(event:any, index: number, ){
    const inputElement = event.target as HTMLInputElement;
    const value = (inputElement.value);
    this.isEnableSaveButton = true;
      this.assignees[index].emHours = value.toString();
  }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChangeRegularHours(event:any, index: number, ){
    const inputElement = event.target as HTMLInputElement;
    const value = (inputElement.value);
    this.isEnableSaveButton = true;
      this.assignees[index].rHours = value.toString();
  }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChangeOverTimeHours(event:any, index:number){
    const inputElement = event.target as HTMLInputElement;
    const value  = inputElement.value;
    this.isEnableSaveButton = true;
    this.assignees[index].otHours = value.toString();
  }
safeNumber(value: string, fallback = 0): number {
    const parsed = Number(noCommaValue(value));
    return isNaN(parsed) ? fallback : parsed;
  }
  async onSubmitLaborHours(){
      
      if(!this.assignees[0].id){
              this.notifyService.error({
                message: 'Please select member to add into list.',
              });
    this.isEnableSaveButton = false;
        return;
      }
    const emHoursRaw = (this.assignees[0].emHours ?? '').trim();
    const eHours = this.safeNumber(emHoursRaw);
    if (
      emHoursRaw &&
      (Number.isNaN(Number(noCommaValue(emHoursRaw))) ||
        (eHours === 0 && emHoursRaw !== '0'))
    ) {
      this.notifyService.error({
        message: 'Please enter valid hours.',
      });
      return;
    }
      const ticketLaborList = this.ticketService.ticketLaborList;
      const getLabor = ticketLaborList.find(x => x.workerId == this.assignees[0].id);
      if(getLabor){
              this.notifyService.error({
                message: 'Selected member already exists.',
              });
              this.isEnableSaveButton = false;
        return;
      }
      if(this.assignees[0].emHours && this.assignees[0].emHours?.includes('-')){
              this.notifyService.error({
                message: 'Negative values are not allowed.',
              });
              this.isEnableSaveButton = false;
        return;
      }
      // if(this.assignees[0].emHours && this.assignees[0].emHours?.includes('.')){
      //         this.notifyService.error({
      //           message: 'Please enter whole numbers only.',
      //         });
      //         this.isEnableSaveButton = false;
      //   return;
      // }

      this.loading = true;
      const labor = new CreateLabor();
        labor.createdById = this.workerId;
        labor.workerId = this.assignees[0].id;
        labor.ticketId = this.ticketId;
        labor.regularHours=parseFloat(noCommaValue(this.assignees[0].rHours? this.assignees[0].rHours: '0'));
        labor.estimated=parseFloat(noCommaValue(this.assignees[0].emHours? this.assignees[0].emHours: '0'));
        labor.overtimeHours = parseFloat(noCommaValue(this.assignees[0].otHours? this.assignees[0].otHours: '0'));
        labor.regularRate=parseFloat(noCommaValue(this.getHourlyRateByUserId(this.assignees[0].id, this.salaryType.Regular).toString()?? '0'));
        labor.overtimeRate = parseFloat(noCommaValue(this.getHourlyRateByUserId(this.assignees[0].id, this.salaryType.OverTime).toString()?? '0'));
      await this.service
          .addLabor(labor)
          .then(async (id) => {

            this.loading=false;
            this.dialogRef.close(id);
          })
          .catch((error) => {
            this.isEnableSaveButton = false;
            this.loading = false;
            error = error.graphQLErrors[0];
            if (error) {
              this.notifyService.error({
                message: error.message,
                type: error.extensions.type,
              });
            } else {
              this.notifyService.error({
                message: 'Failed to add worker hours.',
              });
            }
          });
    }

  getHourlyRateByUserId(userId: string, type:string): number | null {
      // Find the salary record for the given userId
      const salary = this.laborHourRate.find(s => s.userId === userId);

      if (!salary || !salary.salarySetup) {
        return 0; // Return null if no record is found or salarySetup is missing
      }
      try {
        // Parse the salarySetup JSON
        const salarySetup: SalarySetup = JSON.parse(salary.salarySetup);

        // Ensure it's an hourly salary type and contains the expected structure
        if(type == this.salaryType.Regular){
          if (salarySetup.SalaryType === "Hourly" && "EmployeeRate" in salarySetup.Setup) {
            return salarySetup.Setup.EmployeeRate.RegularRate; // Return RegularRate
          }
        }
        else if(type == this.salaryType.OverTime){
          if (salarySetup.SalaryType === "Hourly" && "EmployeeRate" in salarySetup.Setup) {
            return salarySetup.Setup.EmployeeRate.OvertimeRate; // Return RegularRate
          }
        }
        return 0; // Return null if it's not the expected format
      } catch (error) {
        console.error("Error parsing salarySetup JSON:", error);
        return 0;
      }
    }
}
